import { useBrandPlanSchedule, Options as BaseOptions } from 'hooks/queries/schedules/useBrandPlanSchedule'
import { useQueryClient } from 'react-query'
import { calendarKeys } from '../calendar/calendarKeys'
import { isGeneratingContent, isPending } from 'screens/ScheduledPosts/utils'
import { reportError } from 'utils/error'

interface Options extends Omit<BaseOptions, 'refetchInterval'> {
  intervalMs?: number
}

export const usePollBrandPlanSchedule = (id: number, options?: Options) => {
  const queryClient = useQueryClient()

  return useBrandPlanSchedule(id, {
    refetchInterval: (schedule) => {
      try {
        const generatingContents = schedule?.contents.filter((content) => isGeneratingContent(content)) || []
        const scheduleStillProcessing = schedule != null && isPending(schedule.status)

        if (generatingContents.length === 0 && !scheduleStillProcessing) {
          queryClient.invalidateQueries(calendarKeys.all)
          return false
        }
        return options?.intervalMs || 500
      } catch (error) {
        reportError(error, {
          severity: 'error',
          metaData: {
            hook: 'usePollBrandPlanSchedule',
          },
        })
        throw error
      }
    },
    // Keep polling while the tab is in the background so completion is detected
    refetchIntervalInBackground: true,
    // Enable refetch on window focus to prevent stale data in case user leaves and returns to app
    // Disable in test environment to prevent flaky tests
    refetchOnWindowFocus: process.env.NODE_ENV === 'test' ? false : true,
    // Set staleTime to 0 in tests so refetchInterval updates cache properly, otherwise 30 seconds
    staleTime: process.env.NODE_ENV === 'test' ? 0 : 30000,
    ...options,
  })
}
